import { HostedButtonDetails } from '@client/typings/Common';
import { ButtonConfig } from '@components/buttons/types';
// We want to prefix this to the field name before we hash it
// so that we can differentiate between variant inputs and other inputs
// in case the variant is named the same as our other input names
const INTERNAL_VARIANT_NAME_PREFIX = 'NOCODE_VARIANT_';

export const getVariantFieldName = (name: string) => `${INTERNAL_VARIANT_NAME_PREFIX}${name}`;

export const getVariantNames = (optionDetails: HostedButtonDetails['option_details']) =>
  optionDetails?.map((option) => option.name) || [];

// Primarily being used for FPTI
export const getVariantDetails = (
  optionDetails: HostedButtonDetails['option_details'] | ButtonConfig['variants'],
  isEditor: boolean
) => {
  const variantDetails = {};
  optionDetails?.forEach((option, index) => {
    const key = `variant_${index + 1}`;
    const variantNameKey = isEditor ? 'variantName' : 'name';
    const variantOptionsKey = isEditor ? 'variantOptions' : 'selection_details';
    const variantName = option[variantNameKey];
    const optionCount = option[variantOptionsKey]?.length || 0;
    const firstVariantDetails =
      index === 0
        ? {
            has_image:
              option[variantOptionsKey]?.some((variant_option) => !!variant_option.images) || false,
            has_price:
              option[variantOptionsKey]?.some((variant_option) => !!variant_option.price) || false
          }
        : {};
    variantDetails[key] = {
      variant_name: variantName,
      option_count: optionCount,
      ...firstVariantDetails
    };
  });
  return variantDetails;
};
